import { memo } from 'react';
import { components, MultiValueGenericProps } from 'react-select';
import { Tag } from '@chakra-ui/react';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const MultiValueLabelComponent = <IsMulti extends boolean = false>({
  children,
  ...props
}: MultiValueGenericProps<ControlledSelectOption, IsMulti>) => (
  <components.MultiValueLabel {...props}>
    <Tag.Label>{children}</Tag.Label>
  </components.MultiValueLabel>
);

export const MultiValueLabel = memo(
  MultiValueLabelComponent,
) as typeof MultiValueLabelComponent;
